module.exports = __webpack_public_path__ + "static/media/YM14_1.14f39f37.jpg";